import classNames from "classnames";
import React, { useEffect, useState } from "react";

interface LightboxProps {
  isOpened: boolean;
  onClose: () => void;
  children: React.ReactElement<'img'>;
}

export const Lightbox: React.FC<LightboxProps> = ({
  isOpened,
  onClose,
  children
}) => {
  useEffect(() => {
    if (isOpened) {
      document.body.classList.add('scroll-lock');
    } else {
      document.body.classList.remove('scroll-lock');
    }
  }, [isOpened]);

  return  (
    <div
      className={classNames("lightbox", {
        "lightbox--opened": isOpened,
      })}
      onClick={onClose}
    >
      <button className="lightbox__closeBtn">
        Lukk
        <span className="lightbox__closeIcon" />
      </button>
      {children}
    </div>
  );
};
